export namespace Money {
  export function formatDollars(dollars: number) {
    return dollars.toLocaleString("en-AU", {
      currency: "aud",
      currencySign: "standard",
      signDisplay: "auto",
      style: "currency",
      trailingZeroDisplay: "stripIfInteger",
      minimumFractionDigits: 2,
    })
  }
}
